import { render, staticRenderFns } from "./tender-list.vue?vue&type=template&id=909a4e46&scoped=true"
import script from "./tender-list.vue?vue&type=script&lang=js"
export * from "./tender-list.vue?vue&type=script&lang=js"
import style0 from "./tender-list.vue?vue&type=style&index=0&id=909a4e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909a4e46",
  null
  
)

export default component.exports